import { render, staticRenderFns } from "./AgendaSection.vue?vue&type=template&id=7fd79e9f&scoped=true"
import script from "./AgendaSection.vue?vue&type=script&lang=js"
export * from "./AgendaSection.vue?vue&type=script&lang=js"
import style0 from "./AgendaSection.vue?vue&type=style&index=0&id=7fd79e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd79e9f",
  null
  
)

export default component.exports